import { useRecoilState } from 'recoil';

import { FormattedMessage } from 'react-intl';
import { Features } from '~/components/FeatureToggle';
import TabModal, { TabItem } from '~/components/Modal/TabModal';
import useBackendModelPrefetch from '~/hooks/workflows/backend/useBackendModelPrefetch';
import { workflowModalState, WorkflowTypes } from '~/state/atoms/viewerAtoms';
import AppConfig from '~/utils/appconfig';
import AdaptBackendWorkflow from './adapt/AdaptBackendWorkflow';
import ContourBackendWorkflow from './contour/ContourBackendWorkflow';
import DataUpload from './data-upload';
import DosePredictionBackendWorkflow from './dose/DosePredictionBackendWorkflow';
import ImageTranslationBackendWorkflow from './image/ImageTranslationBackendWorkflow';
import Segmetrics from './verify/SegmetricsModal';

export default function BackendWorkflows() {
    const [workflowModal, setWorkflowModal] =
        useRecoilState(workflowModalState);

    // Prefetch model lists so they're cached before the dialog opens
    useBackendModelPrefetch();

    const workflows = [
        AppConfig.isFeatureEnabled(Features.CONTOUR_WORKFLOW) && {
            name: <FormattedMessage id="contourPlus" />,
            description: <FormattedMessage id="contourPlusDescription" />,
            content: <ContourBackendWorkflow />,
            type: WorkflowTypes.CONTOUR,
        },
        AppConfig.isFeatureEnabled(Features.DOSE_WORKFLOW) && {
            name: <FormattedMessage id="dosePlus" />,
            description: <FormattedMessage id="dosePlusDescription" />,
            content: <DosePredictionBackendWorkflow />,
            type: WorkflowTypes.DOSE,
        },
        AppConfig.isFeatureEnabled(Features.IMAGE_TRANSLATION_WORKFLOW) && {
            name: <FormattedMessage id="imagePlus" />,
            description: <FormattedMessage id="imagePlusDescription" />,
            content: <ImageTranslationBackendWorkflow />,
            type: WorkflowTypes.IMAGE,
        },
        AppConfig.isFeatureEnabled(Features.ADAPT_WORKFLOW) && {
            name: <FormattedMessage id="adaptPlus" />,
            description: <FormattedMessage id="adaptPlusDescription" />,
            content: <AdaptBackendWorkflow />,
            type: WorkflowTypes.ADAPT,
        },
        AppConfig.isFeatureEnabled(Features.SEG_VERIFY) && {
            name: <FormattedMessage id="verify" />,
            description: <FormattedMessage id="verifyDescription" />,
            content: <Segmetrics />,
            type: WorkflowTypes.SEG_VERIFY,
        },
        AppConfig.isFeatureEnabled(Features.DATA_UPLOAD) && {
            name: <FormattedMessage id="shareData" />,
            description: <FormattedMessage id="shareDataDescription" />,
            content: <DataUpload />,
            type: WorkflowTypes.DATA_UPLOAD,
        },
    ].filter(Boolean) as TabItem[];

    return (
        <TabModal
            maxWidth={800}
            open={workflowModal.open}
            setOpen={(open) => setWorkflowModal({ ...workflowModal, open })}
            items={workflows}
            selectedPage={workflowModal.page}
            setSelectedPage={(page) =>
                setWorkflowModal({
                    ...workflowModal,
                    page: page as WorkflowTypes,
                })
            }
        />
    );
}
